import React from 'react';
import { motion } from 'framer-motion';
import ParallaxHero from '../../components/ui/ParallaxHero';
import Section from '../../components/ui/Section';
import Button from '../../components/ui/Button';
import GlowingPortal from '../../components/ui/GlowingPortal';
import CinematicText from '../../components/ui/CinematicText';

const About = () => (
  <div>
    <ParallaxHero
      image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/0a8dbd1ab6196d088ee699a1d0e6492e.png"
      tag="Die Frau hinter der Vision"
      title="Hi, ich bin Jennifer Gräser. Visionärin & Heilerin."
      titleHighlight="Heilerin."
      subtitle="Meine Mission: Anspruchsvolle Frauen in ihre absolute Schöpferkraft führen."
    />

    <Section className="overflow-hidden bg-dark">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
        <div>
          <div className="space-y-6 text-cream/70 font-light text-lg leading-relaxed">
            <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              Lange Zeit dachte ich, ich müsste in der maskulinen Energie funktionieren, um erfolgreich zu sein.
              Ich war ausgebrannt, getrieben und emotional leer.
            </motion.p>
            <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
              Bis ich verstanden habe: Wahre Macht liegt in der Hingabe. In der{' '}
              <GlowingPortal to="/beziehungsheilung-fuer-frauen">Heilung unserer tiefsten Wunden</GlowingPortal>.
              In der Wiederentdeckung unserer <strong>Göttlichen Fülle</strong>.
            </motion.p>
            <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}>
              Heute begleite ich anspruchsvolle Frauen dabei, aus dem{' '}
              <GlowingPortal to="/female-leadership-fuer-frauen">Hustle-Modus</GlowingPortal> auszusteigen.
            </motion.p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.6 }}
            className="mt-12 p-8 border border-white/10 bg-white/5 backdrop-blur-md"
            style={{ borderLeft: '2px solid #D4AF37', boxShadow: '-4px 0 30px rgba(212,175,55,0.15)' }}
          >
            <h3 className="text-xl font-serif text-gold mb-4">Meine Mission</h3>
            <p className="text-cream/80 italic font-serif leading-relaxed">
              "Ich kreiere Räume für Frauen, in denen sie sich sicher fühlen, ihre Masken fallen zu lassen
              und in ihre absolute Schöpferkraft – ihre Queen-Energie – zu treten."
            </p>
          </motion.div>
        </div>

        <div className="relative group">
          <div className="absolute inset-0 bg-gold/10 translate-x-4 translate-y-4 rounded-sm border border-gold/30 transition-all duration-700 group-hover:translate-x-6 group-hover:translate-y-6" />
          <img
            src="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/0a8dbd1ab6196d088ee699a1d0e6492e.png"
            alt="Jennifer Gräser"
            className="relative z-10 w-full aspect-[3/4] object-cover object-top rounded-sm grayscale group-hover:grayscale-0 transition-all duration-1000"
          />
        </div>
      </div>
    </Section>

    <Section className="bg-darker border-t border-white/5 text-center">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-4xl font-serif mb-6">Bereit für Dein nächstes Level?</h2>
        <p className="text-cream/60 mb-10 font-light text-lg">
          Lass uns herausfinden, wo Du stehst und wie ich Dich am besten unterstützen kann.
        </p>
        <Button variant="gold" className="mx-auto">Jetzt GlücksCall anfragen</Button>
      </div>
    </Section>
  </div>
);

export default About;